<template>
	<div class="table-responsive">
		<table class="table table-bordered closeout-table">
			<thead>
				<tr>
					<th>Image</th>
					<th>Product Details</th>
					<th>Price</th>
					<th>Qty Available</th>
					<th>Qty</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="products.length === 0">
					<td colspan="6" class="text-center py-4">
						No products found matching your criteria.
					</td>
				</tr>
				<tr v-for="product in products" :key="product.id">
					<td class="text-center align-middle">
						<img
							v-if="product.image"
							:src="product.image"
							:alt="product.name"
							class="closeout-thumb"
							@click="$emit('view', product)"
							role="button"
						/>
					</td>
					<td
						class="align-middle product-details-cell"
						role="button"
						@click="$emit('view', product)"
					>
						<span class="fw-bold product-details-title">
							{{ product.name }}
						</span>
						<div class="product-details-meta text-muted small mt-1">
							<span v-if="product.categories.length">{{
								product.categories.join(', ')
							}}</span>
							<span v-if="product.manufacturer">
								&middot; {{ product.manufacturer }}</span
							>
							<span v-if="product.sku"> &middot; SKU: {{ product.sku }}</span>
							<span v-if="product.serial">
								&middot; Serial #: {{ product.serial }}</span
							>
						</div>
					</td>
					<td class="align-middle text-nowrap">
						<span class="text-decoration-line-through text-muted">
							${{ product.regular_price.toFixed(2) }}/{{ product.unit || 'EA' }}
						</span>
						<br />
						${{ product.sale_price.toFixed(2) }}/{{ product.unit || 'EA' }}
						<span v-if="product.discount_pct" class="text-danger">
							(-{{ product.discount_pct }}%)
						</span>
					</td>
					<td class="align-middle text-center">
						{{
							product.stock_quantity !== null
								? product.stock_quantity.toLocaleString()
								: '—'
						}}
						{{ product.unit || '' }}
					</td>
					<td class="align-middle">
						<div class="d-flex align-items-center gap-1">
							<input
								v-model.number="product._qty"
								type="number"
								class="form-control form-control-sm closeout-qty-input"
								min="0"
							/>
							<span class="text-muted small">{{ product.unit || 'EA' }}</span>
						</div>
					</td>
					<td class="align-middle text-center">
						<span v-if="product._added" class="text-success fw-bold small">
							&#10004; Added
						</span>
						<button
							v-else
							class="btn btn-sm btn-outline-primary text-nowrap"
							:disabled="product._adding || !product._qty"
							@click="$emit('add-to-cart', product)"
						>
							<span
								v-if="product._adding"
								class="spinner-border spinner-border-sm"
							></span>
							<span v-else>ADD TO ORDER</span>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: 'CloseoutTable',
	props: {
		products: { type: Array, required: true },
	},
	emits: ['view', 'add-to-cart'],
};
</script>
